import { ChartsContainer } from '@anytag/shared-atoms';
import { HAS_NO_ESTIMATED_TEXT, THEME } from '@anytag/shared-constants';
import {
  AgeBreakdownChart,
  AreaProvinceCityChart,
  BarChartWithMoreModal,
  GenderBreakdownChart
} from '@anytag/shared-molecules';
import { useXhsAccountInterestQuery, useXhsProfileAudienceQuery } from '@anytag/graphql';
import { useInfluencerProfileOpacityContent } from '../../hooks';
import { InfluencerSelectedAccountInfo } from '../../types';
import { InfluencerProfileAudienceWrapper } from '../shared';

export interface InfluencerXhsProfileAudienceProps {
  influencerId: number;
  socialAccount: InfluencerSelectedAccountInfo;
}

export const InfluencerXhsProfileAudience = ({ influencerId, socialAccount }: InfluencerXhsProfileAudienceProps) => {
  const { opacityContent, hasEstimatedDemographics } = useInfluencerProfileOpacityContent({
    influencerId,
    socialAccount
  });
  const { data: audienceData, loading } = useXhsProfileAudienceQuery({
    variables: { pk: influencerId, socialAccountId: socialAccount.id }
  });
  const { data: accountInterestData } = useXhsAccountInterestQuery({
    variables: {
      pk: influencerId,
      socialAccountId: socialAccount.id
    }
  });

  const chartOpacityContent = hasEstimatedDemographics ? opacityContent : { wrapperText: HAS_NO_ESTIMATED_TEXT };
  const deviceRates = accountInterestData?.xhsAccountInterest?.deviceRates;
  const interestRates = accountInterestData?.xhsAccountInterest?.interestRates;

  return (
    <InfluencerProfileAudienceWrapper
      loading={loading}
      data={audienceData?.xhsProfileAudience}
      hasEstimatedDemographics={hasEstimatedDemographics}
    >
      {({ data: { maleRate, femaleRate, ageRates, provinceRates, cityRates } }) => (
        <>
          <ChartsContainer
            css={{ height: '385px' }}
            elements={[
              <GenderBreakdownChart maleRate={maleRate} femaleRate={femaleRate} {...chartOpacityContent} />,
              <AgeBreakdownChart
                ageGroup={ageRates.ageGroup}
                totalRate={ageRates.rate}
                xAxisCategories={ageRates.ageGroup?.map((item) =>
                  item.start === undefined
                    ? `-${item.end}`
                    : item.end === undefined
                      ? `${item.start}+`
                      : `${item.start}-${item.end}`
                )}
                {...chartOpacityContent}
              />
            ]}
          />
          <ChartsContainer
            css={{ height: '385px', borderTop: THEME.table.row.border }}
            elements={[
              <AreaProvinceCityChart provinceRates={provinceRates || []} cityRates={cityRates || []} hasRelativeMaxY />,
              <BarChartWithMoreModal
                dataset={deviceRates || []}
                title="Device Distribution"
                modalTitle="Device Distribution"
                hasRelativeMaxY
              />,
              <BarChartWithMoreModal
                dataset={interestRates || []}
                title="Interest"
                modalTitle="Interest"
                hasRelativeMaxY
                hasCategoriesTranslate
              />
            ]}
          />
        </>
      )}
    </InfluencerProfileAudienceWrapper>
  );
};
